import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';



export interface SnackbarData {
  message: string;
  label?: string;
  link?: string;
}

@Component({
  selector: 'app-snackbar',
  imports: [
    MatButtonModule
  ],
  templateUrl: './snackbar.component.html',
  styleUrl: './snackbar.component.scss',
})
export class SnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: SnackbarData,
    private snackBarRef: MatSnackBarRef<SnackbarComponent>
  ) { }

  onClose() {
    this.snackBarRef.dismissWithAction();
  }

  onOpenLink() {
    if (this.data.link) {
      window.open(this.data.link, '_blank');
    }
    this.snackBarRef.dismissWithAction();
  }
}
